import React from 'react';
import { Stack, SxProps, Theme } from '@mui/material';

import checkerboard from '@/assets/img/checkerboard.png';
import { IMAGES } from '@/core';
import palette from '@/theme/palette.ts';

const styles: React.CSSProperties = {
  width: '40px',
  height: '40px',
  objectFit: 'cover',
  border: `1px solid ${palette.surface.lighter}`,
  borderRadius: '2px',
  padding: '1px',
  backgroundColor: palette.background.default,
};

export const ImageCell = ({ imageId, sx }: { imageId: number | null; sx?: SxProps<Theme> }) => {
  const imageSrc = imageId ? `${window.API_URL}/${IMAGES}/${imageId}/thumbnail` : '';

  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', height: '100%', ...sx }}
    >
      {imageSrc ? (
        <img src={imageSrc} style={styles} alt="photo" />
      ) : (
        <img src={checkerboard} style={styles} alt="noPhoto" />
      )}
    </Stack>
  );
};
